import React, { Component } from 'react';
import { UploadPanel } from "../components";
import { constant } from "../helpers";
import './Site.css';
import {Redirect} from "react-router-dom";

export default class ProductionHistoryUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToProductionSummary: false
        }
    }

    render() {
        if (this.state.redirectToProductionSummary){
            return (<Redirect to="/production_summary" />);
        }

        return (
            <div>
                <UploadPanel
                    uploadType={constant.uploadType.productionHistorical}
                    onSuccess={() => this.setState({redirectToProductionSummary: true})}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ProductionHistoryUpload.js